export default "__VITE_ASSET__DAA0JIsW__"